export default "__VITE_ASSET__72a5fb96__"